import { useRoute } from '#imports';

import { getVersionFromQuery } from '~/utils';
import { createWordpressApi } from '~/api/wordpress';
import { createIronMaidenApi } from '~/api/ironMaiden';
import { createViewsApi } from '~/api/views';
import { createTalkerApi } from '~/api/talker';
import { createPushApi } from '~/api/push';
import { createSpecialApi } from '~/api/special';
import { createQuizApi } from '~/api/quiz';
import { createMascotApi } from '~/api/mascot';
import { createHealthApi } from '~/api/health';
import { createPusherApi } from '~/api/pusher';
import { createReactionsApi } from '~/api/reactions';
import { createRecipesApi } from '~/api/recipes';

export default defineNuxtPlugin((nuxtApp) => {
  const { $store, $logger } = nuxtApp;

  const route = useRoute();
  const version = getVersionFromQuery(route.query);

  nuxtApp.provide('wordpressApi', createWordpressApi({ $logger, version }));
  nuxtApp.provide('ironMaidenApi', createIronMaidenApi({ $logger, version }));
  nuxtApp.provide('viewsApi', createViewsApi({ $fetch, $logger }));
  nuxtApp.provide('talkerApi', createTalkerApi({ $logger }));
  nuxtApp.provide('pushApi', createPushApi({ $logger }));
  nuxtApp.provide('specialApi', createSpecialApi({ $logger }));
  nuxtApp.provide('quizApi', createQuizApi({ $logger }));
  nuxtApp.provide('mascotApi', createMascotApi({ $logger }));
  nuxtApp.provide('healthApi', createHealthApi({ $logger, $store }));
  nuxtApp.provide('pusherApi', createPusherApi({ $logger, $store, route }));
  nuxtApp.provide('reactionsApi', createReactionsApi({ $logger, $store, route }));
  nuxtApp.provide('recipesApi', createRecipesApi({ $logger }));
});
